import { namespace } from 'wsm-tagging-utils';

const runDecoratorUtils = (win) => {
	namespace(win, 'DDC.tracking.adobe_launch.util');

	const {
		DDC: { tracking }
	} = win;
	/**
	 * Utility class to handle all data transformations and lookups for
	 * FD tracking events.
	 *
	 * @param {Object} win (optional) an instance of the global window object
	 * @constructor
	 */
	tracking.adobe_launch.util.DecoratorUtils =
		tracking.adobe_launch.util.DecoratorUtils ||
		(function buildDecoratorUtil() {
			// ======================================================================
			// ------------------ Private Variables and Functions -------------------
			// ======================================================================

			class DecoratorUtils {
				/**
				 * Elements that match or live within one of these defined
				 * strings will be assigned that particular string. Map is iterated
				 * over so put broader selectors towards the bottom.
				 */
				getStringForElement = function getStringForElement(
					element,
					map
				) {
					if (element instanceof Element) {
						// eslint-disable-next-line no-restricted-syntax
						for (const [string, selector] of map) {
							if (element.closest(selector) !== null) {
								return string;
							}
						}
					}
					return '';
				};

				/**
				 * Returns the first word of a string separated by space by default
				 */
				getFirstWord = function getFirstWord(
					eventDataProperty,
					char = ' '
				) {
					return (eventData) => {
						const str = eventData[eventDataProperty];
						return str && str.split(char).shift();
					};
				};

				parseStringValue = function parseStringValue(string, values) {
					if (
						string &&
						typeof string === 'string' &&
						values &&
						Object.entries(values).length
					) {
						return string.replace(/{(.*?)}/g, (match, key) => {
							return values[key];
						});
					}
					return string;
				};

				replaceObjectValues(objectIn, values) {
					const object = objectIn;
					Object.entries(object).forEach(([property, value]) => {
						object[property] =
							typeof value === 'function'
								? value(values)
								: this.parseStringValue(value, values);
					});
					return object;
				}
			}

			return DecoratorUtils;
		})();
};

export default runDecoratorUtils;
